import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { useAuthStore } from './store/auth.store';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ClientList from './pages/clients/ClientList';
import ClientDetail from './pages/clients/ClientDetail';
import ClientForm from './pages/clients/ClientForm';
import ContactList from './pages/contacts/ContactList';
import ContactForm from './pages/contacts/ContactForm';
import ProjectList from './pages/projects/ProjectList';
import ProjectDetail from './pages/projects/ProjectDetail';
import ProjectForm from './pages/projects/ProjectForm';
import TemplateList from './pages/surveys/TemplateList';
import TemplateBuilder from './pages/surveys/TemplateBuilder';
import DispatchWizard from './pages/surveys/DispatchWizard';
import DispatchList from './pages/surveys/DispatchList';
import DispatchDetail from './pages/surveys/DispatchDetail';
import SurveyForm from './pages/surveys/SurveyForm';
import Reports from './pages/reports/Reports';
import Settings from './pages/settings/Settings';
import UserManagement from './pages/settings/UserManagement';
import AuditLog from './pages/settings/AuditLog';

function App() {
  const setLoading = useAuthStore((state) => state.setLoading);
  const initialize = useAuthStore((state) => state.initialize);

  useEffect(() => {
    initialize();
    setLoading(false);
  }, [initialize, setLoading]);

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/survey/:token" element={<SurveyForm />} />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />

        {/* Clients */}
        <Route path="clients" element={<ClientList />} />
        <Route path="clients/new" element={<ClientForm />} />
        <Route path="clients/:id" element={<ClientDetail />} />
        <Route path="clients/:id/edit" element={<ClientForm />} />

        {/* Contacts */}
        <Route path="contacts" element={<ContactList />} />
        <Route path="contacts/new" element={<ContactForm />} />
        <Route path="contacts/:id/edit" element={<ContactForm />} />

        {/* Projects */}
        <Route path="projects" element={<ProjectList />} />
        <Route path="projects/new" element={<ProjectForm />} />
        <Route path="projects/:id" element={<ProjectDetail />} />
        <Route path="projects/:id/edit" element={<ProjectForm />} />

        {/* Surveys */}
        <Route path="surveys/templates" element={<TemplateList />} />
        <Route path="surveys/templates/new" element={<TemplateBuilder />} />
        <Route path="surveys/templates/:id/edit" element={<TemplateBuilder />} />
        <Route path="surveys/dispatches" element={<DispatchList />} />
        <Route path="surveys/dispatches/new" element={<DispatchWizard />} />
        <Route path="surveys/dispatches/:id" element={<DispatchDetail />} />

        {/* Reports */}
        <Route path="reports" element={<Reports />} />

        {/* Settings */}
        <Route path="settings" element={<Settings />} />
        <Route path="settings/users" element={<UserManagement />} />
        <Route path="settings/audit-log" element={<AuditLog />} />
      </Route>
    </Routes>
  );
}

export default App;
